/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *axios 封装
 */
// import { Loading } from 'element-ui';
import baseURL from './basePath'
import Axios from 'axios';
import router from '@/router/index';
import utils from './utils'
const fetch = Axios.create({
  withCredentials: false,
  baseURL,
  timeout: 20000, // 设置超时时间
});
const time = null

// 请求发送前拦截，根据地址重新配置域名，再子路由请求时必须加/ 例如：请求 localhost:80/app/inset  fetch.get('/app/inset');
fetch.interceptors.request.use(
  function(config) {
    const token = utils.getCookie('X-Access-Token');
    config.headers = {'X-Access-Token': token || sessionStorage.getItem('X-Access-Token') || ''};
    if (!vm.isLoading) {
		if(config.url != "/v1/app/OrderAddPay" && config.url != "/v1/app/OrderPay" && config.url != "/v1/app/Recharge" && config.url != "/v1/app/SendCode" && config.url != "https://upload-z2.qiniup.com"){
			utils.loadGif.showLoading();
		}
    }
    return config;
  },
  // 对请求错误做些什么
  function(error) {
    utils.loadGif.hideLoading();
    return Promise.reject(error)
  }
);

// 添加响应拦截器
fetch.interceptors.response.use(
  function(response) {
    utils.loadGif.hideLoading();
    return response;
  },
  function(error) {
    utils.loadGif.hideLoading();
    const {
      status,
      data
    } = error.response;
    switch (status) {
      case 401:
        router.push('/login');
        vm.$message(data.error.message);
        break;
      case 403:
        if (data.error.message != '余额不足' && data.error.message != '登录出现问题咯') {
          vm.$message(data.error.message);
        }
        return error.response
      case 500:
        vm.$message('系统繁忙');
        break;
      default:
        vm.$message(data.error.message);
        return Promise.reject(data);
        break;
    }
  });

export default fetch;
